// removed by extract-text-webpack-plugin
module.exports = {"root":"BandMember__root___nReXZ","content":"BandMember__content___1xts8","background":"BandMember__background___1n9e4"};


//////////////////
// WEBPACK FOOTER
// ./app/views/Band/BandMember.css
// module id = 105
// module chunks = 0